import { render, staticRenderFns } from "./TicketDetailLayout.vue?vue&type=template&id=560d6f10"
import script from "./TicketDetailLayout.vue?vue&type=script&lang=js"
export * from "./TicketDetailLayout.vue?vue&type=script&lang=js"
import style1 from "./TicketDetailLayout.vue?vue&type=style&index=1&id=560d6f10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports